import React from "react";
import { toast } from "react-toastify";
interface WebQRRedirectProps {
  sessionId: string;
  serverKey: string;
}

/**
 * Simple redirect page shown when QR code is scanned on web
 * Gives user option to continue on mobile for better camera quality
 */
export const WebQRRedirect: React.FC<WebQRRedirectProps> = ({ sessionId, serverKey }) => {
  const search = typeof window !== "undefined" ? window.location.search : "";
  const mobileUrl = `https://astra-sdk-testing.vercel.app/mobile-kyc/${sessionId}${search}`;
  
  const handleContinueOnMobile = () => {
    // Copy mobile URL to clipboard
    navigator.clipboard.writeText(`${mobileUrl}`).then(() => {
      toast.success('Mobile URL copied to clipboard! Open it on your mobile device.');
    }).catch(() => {
      // Fallback if clipboard API fails
      const textArea = document.createElement('textarea');
      textArea.value = `${mobileUrl}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      toast.success('Mobile URL copied! Open it on your mobile device.');
    });
  };

  const handleContinueOnWeb = () => {
    // Continue KYC on web by redirecting to mobile page (it will work on web too)
    window.location.href = `https://astra-sdk-testing.vercel.app/mobile-kyc/${sessionId}${search}`;
  };

  return (
    <div className="qr-fullscreen">
      <div style={{ 
        textAlign: "center", 
        padding: "32px",
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
        width: "100%",
        marginTop: "20px",
        marginBottom: "20px"
      }}>
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>📱</div>
        
        <h1 style={{ 
          margin: "0 0 16px 0", 
          color: "#1f2937", 
          fontSize: "24px",
          fontWeight: "600"
        }}>
          Continue on Mobile
        </h1>
        
        <p style={{ 
          margin: "0 0 24px 0", 
          color: "#6b7280", 
          fontSize: "16px",
          lineHeight: "1.5"
        }}>
          For the best KYC experience with high-quality camera capture, 
          we recommend continuing on your mobile device. However, you can 
          also continue on web if you prefer.
        </p>

        <div style={{ 
          background: "#f3f4f6",
          padding: "16px",
          borderRadius: "8px",
          marginBottom: "24px",
          fontSize: "14px",
          color: "#374151",
          wordBreak: "break-all"
        }}>
          <strong>Mobile URL:</strong><br />
          {mobileUrl}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <button
            onClick={handleContinueOnWeb}
            style={{
              width: "100%",
              padding: "12px 16px",
              background: "#1f6feb",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px"
            }}
          >
            🖥️ Continue on Web
          </button>

          <button
            onClick={handleContinueOnMobile}
            style={{
              width: "100%",
              padding: "12px 16px",
              background: "transparent",
              color: "#6b7280",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              fontSize: "16px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px"
            }}
          >
            📋 Copy Mobile URL
          </button>
        </div>

        <p style={{ 
          margin: "16px 0 0 0", 
          color: "#9ca3af", 
          fontSize: "12px" 
        }}>
          Session ID: {sessionId}
        </p>
      </div>
    </div>
  );
};
